import { render, staticRenderFns } from "./AddProduk.vue?vue&type=template&id=dbcaf982&"
import script from "./AddProduk.vue?vue&type=script&lang=js&"
export * from "./AddProduk.vue?vue&type=script&lang=js&"
import style0 from "./AddProduk.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports